import { render, staticRenderFns } from "./PersistentDialog.vue?vue&type=template&id=2aa9dc6c"
import script from "./PersistentDialog.vue?vue&type=script&lang=js"
export * from "./PersistentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports